import SelectAllController from './select_all_controller'
import { current } from '../helpers'
import { messageArchivingMessageBoardsPath, messageArchivingMessageBoardMessagesPath } from '../routes'

const MESSAGE_BOARDS_FRAME_ID = 'message_archiving_message_boards'
const MESSAGES_FRAME_ID = 'message_archiving_messages'

export default class extends SelectAllController {
  static targets = [
    'projectSelect', 'submitButton', 'buttonCount',
    'messageBoardsContainer', 'messagesContainer',
    'projectStep', 'messageBoardStep', 'messagesStep'
  ]

  connect () {
    const mbFrame = document.getElementById(MESSAGE_BOARDS_FRAME_ID)
    if (mbFrame) this.initialMessageBoardsHTML = mbFrame.innerHTML
    const msgFrame = document.getElementById(MESSAGES_FRAME_ID)
    if (msgFrame) this.initialMessagesHTML = msgFrame.innerHTML
  }

  selectProject () {
    this.resetSubmitButton()
    this.resetMessages()
    this.setStepState(this.messagesStepTarget, 'disabled')
    if (this.projectId) {
      this.loadMessageBoards()
      this.setStepState(this.projectStepTarget, 'done')
      this.setStepState(this.messageBoardStepTarget, 'active')
    } else {
      this.resetMessageBoards()
      this.setStepState(this.projectStepTarget, 'active')
      this.setStepState(this.messageBoardStepTarget, 'disabled')
    }
  }

  selectMessageBoard ({ target }) {
    this.loadMessages(target.value)
    this.setStepState(this.messageBoardStepTarget, 'done')
    this.setStepState(this.messagesStepTarget, 'active')
    this.submitButtonVisible = true
    this.submitButtonDisabled = true
  }

  toggle (e) {
    super.toggle(e)
    this.updateSubmitButtonState()
  }

  refresh () {
    super.refresh()
    this.updateSubmitButtonState()
  }

  // Private

  loadMessageBoards () {
    const frame = document.getElementById(MESSAGE_BOARDS_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.cardsGridSkeleton())
    frame.src = messageArchivingMessageBoardsPath(current.account.id, this.projectId)
  }

  loadMessages (messageBoardId) {
    const frame = document.getElementById(MESSAGES_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.listSkeleton())
    frame.src = messageArchivingMessageBoardMessagesPath(current.account.id, this.projectId, messageBoardId)
  }

  resetMessageBoards () {
    const frame = document.getElementById(MESSAGE_BOARDS_FRAME_ID)
    if (!frame || !this.initialMessageBoardsHTML) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialMessageBoardsHTML
  }

  resetMessages () {
    const frame = document.getElementById(MESSAGES_FRAME_ID)
    if (!frame || !this.initialMessagesHTML) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialMessagesHTML
  }

  updateSubmitButtonState () {
    this.submitButtonDisabled = this.checked.length === 0
    this.buttonCountContent = this.checked.length
  }

  // eslint-disable-next-line accessor-pairs
  set buttonCountContent (count) {
    this.buttonCountTarget.textContent = count === 1
      ? '1 message'
      : `${count} messages`
  }

  get projectId () {
    const hidden = this.element.querySelector('input[type="hidden"][name="message_archiving[project_id]"]')
    return hidden?.value || this.projectSelectTarget.value
  }
}
